import { useUserActivity } from "./useUserActivity";

export default function UserActivityTracker({ pagename }) {
  useUserActivity(pagename); // call the hook inside
  return null; // nothing is rendered
}